import React from "react";

import { PageHeader, Statistic, Descriptions, Divider } from "antd";

import Moment from "moment";
import { DATE_FORMAT } from "../../../../../core/utils/i18n-js";

import StatisticAmount from "../../../../../core/components/widget/amountInline/statistic";

/**
 *
 */
export default class Show extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.match.params.id,
        };
    }

    _goBack = () => {
        this.props.history.goBack();
    };

    render() {
        const { data } = this.props;

        return (
            <>
                <div className="site-page-header-ghost-wrapper">
                    <PageHeader
                        ghost={false}
                        className="site-page-header"
                        onBack={this._goBack}
                        title={data.payment.id}
                        subTitle="Payment"
                    >
                        <Divider orientation="left" plain>
                            {" "}
                            General Information{" "}
                        </Divider>

                        <Descriptions size="medium" column={2}>
                            <Descriptions.Item label="Vendor">
                                {data.payment.vendor ? data.payment.vendor.name : ""}
                            </Descriptions.Item>
                            <Descriptions.Item label="Date">
                                {" "}
                                {Moment(data.payment.date).format(DATE_FORMAT)}{" "}
                            </Descriptions.Item>
                            <Descriptions.Item>
                                {" "}
                                <StatisticAmount
                                    title="Amount"
                                    prefix={data.payment.amountValue}
                                    value={data.payment.amountType}
                                />
                            </Descriptions.Item>
                            <Descriptions.Item label="Notes"> {data.payment.notes} </Descriptions.Item>
                        </Descriptions>
                    </PageHeader>
                </div>
            </>
        );
    }
}
